// extracted by mini-css-extract-plugin
export var hidden = "_p7-1";
export var visible = "_p7-0";